// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { TimeModule } from "modules/workflows/Analysis/Time/TimeModule";

@autoinject
export class TimeSettingsModal extends SettingsModal<TimeModule> {}
